import React from 'react';
import { colors } from '@styleseat/brand';

type ClockThreeIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ClockThreeIcon = ({
  width = 24,
  height = 24,
  color = colors.red,
  ...restProps
}: ClockThreeIconProps) => (
  <svg
    width={height}
    height={width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <g id="24 / clock / three">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM17 11H13V6H11V13H17V11Z"
        fill={color}
      />
    </g>
  </svg>
);

export default ClockThreeIcon;
